import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetRecentGamersSummary } from "../../api-clients/tournamentsClient";

function useRecentGamersSummaryQuery(gameId = "") {
  const query = useQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.RECENT_GAMERS_SUMMARY],
    queryFn: () => handleGetRecentGamersSummary(gameId),
    enabled: !!gameId,
  });

  return query;
}

export default useRecentGamersSummaryQuery;
